<template>
	<div class="xinxi" v-if="showXinxi">
		<div class="con">
			<p class="con_tit"><span></span><strong>重要信息变更</strong></p>
			<div class="con_con">
				<p style="color: red;text-indent: 40px;">说明：现有单位会员登录系统，请您务必更新完善一下相关信息，新入会单位会员无需操作</p>
				<div class="form">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm msg_box">
						<p class="tit_name">企业信息</p>

						<div class="default">
							<!--单位名称-->
							<el-form-item class="type1" prop="name">
								<el-input v-model="ruleForm.name" placeholder="单位名称" autocomplete="on"></el-input>
							</el-form-item>

							<!--行业类别-->
							<el-form-item class="type2" prop="sort">
								<el-select v-model="ruleForm.sort" placeholder="行业类别">
									<el-option label="农林牧渔业" value="1"></el-option>
									<el-option label="采矿业" value="2"></el-option>
									<el-option label="制造业" value="3"></el-option>
									<el-option label="电力、热力，燃气及水生产和供应业" value="4"></el-option>
									<el-option label="建筑业" value="5"></el-option>
									<el-option label="批发和零售业" value="6"></el-option>
									<el-option label="交通运输，仓储和邮政业" value="7"></el-option>
									<el-option label="住宿和餐饮业" value="8"></el-option>
									<el-option label="信息传输，软件和信息技术服务业" value="9"></el-option>
									<el-option label="金融业" value="10"></el-option>
									<el-option label="房地产业" value="11"></el-option>
									<el-option label="租赁和商务服务业" value="12"></el-option>
									<el-option label="科学研究和技术服务业" value="13"></el-option>
									<el-option label="水利、环境和公共设施管理业" value="14"></el-option>
									<el-option label="教育" value="15"></el-option>
									<el-option label="卫生和社会工作" value="16"></el-option>
									<el-option label="文化、体育和娱乐业" value="17"></el-option>
									<el-option label="公共管理、社会保障和社会组织" value="18"></el-option>
									<el-option label="国际组织" value="19"></el-option>
								</el-select>
							</el-form-item>
						</div>

						<div class="default">
							<!--通讯地址-->
							<el-form-item class="type1" prop="addres1">
								<el-input v-model="ruleForm.addres1" placeholder="通讯地址"></el-input>
							</el-form-item>

							<!--职工人数-->
							<!--<el-form-item class="type2" prop="people_num">
								<el-select v-model="ruleForm.people_num" placeholder="职工人数">
									<el-option label="100-999" value="100-999"></el-option>
									<el-option label="1000-4999" value="1000-4999"></el-option>
									<el-option label="5000-9999" value="5000-9999"></el-option>
									<el-option label="10000以上" value="10000以上"></el-option>
								</el-select>
							</el-form-item>-->
							<el-form-item class="type2" prop="people_num">
								<el-select v-model="ruleForm.people_num" placeholder="职工人数">
									<el-option label="小于100" value="小于100"></el-option>
									<el-option label="100-999" value="100-999"></el-option>
									<el-option label="1000-1999" value="1000-1999"></el-option>
									<el-option label="2000-4999" value="2000-4999"></el-option>
									<el-option label="5000-9999" value="5000-9999"></el-option>
									<el-option label="10000以上" value="10000以上"></el-option>
								</el-select>
							</el-form-item>
						</div>
						
						<el-form-item  prop="prov">
							<el-select v-model="ruleForm.prov" style="width: 100%;display: block;" placeholder="请选择省份">
								<el-option v-for="(option,index) in arr" :key="index" :value="option.name">
									{{ option.name }}
								</el-option>
							</el-select>
						</el-form-item>
						
						<div class="default">
							<!--单位网址-->
							<el-form-item class="type1" prop="addres2">
								<el-input v-model="ruleForm.addres2" placeholder="单位网址(选填)"></el-input>
							</el-form-item>

							<!--企业性质-->
							<!--<el-form-item class="type2" prop="kind">
								<el-select v-model="ruleForm.kind" placeholder="企业性质">
									<el-option label="国有企业" value="国有企业"></el-option>
									<el-option label="集体企业" value="集体企业"></el-option>
									<el-option label="联营企业" value="联营企业"></el-option>
									<el-option label="股份合作制企业" value="股份合作制企业"></el-option>
									<el-option label="私营企业" value="私营企业"></el-option>
									<el-option label="合伙企业" value="合伙企业"></el-option>
									<el-option label="有限责任公司" value="有限责任公司"></el-option>
									<el-option label="股份有限公司" value="股份有限公司"></el-option>
								</el-select>
							</el-form-item>-->
							<el-form-item class="type2" prop="kind">
								<el-select v-model="ruleForm.kind" placeholder="企业性质">
									<el-option label="中央企业" value="中央企业"></el-option>
									<el-option label="地方国有企业" value="地方国有企业"></el-option>
									<el-option label="私营企业" value="私营企业"></el-option>
									<el-option label="全民所有制" value="全民所有制"></el-option>
									<el-option label="集体所有制" value="集体所有制"></el-option>
									<el-option label="外商及港澳台商投资企业" value="外商及港澳台商投资企业"></el-option>
									<el-option label="事业单位" value="事业单位"></el-option>
									<el-option label="央企事业单位" value="央企事业单位"></el-option>
									<el-option label="其他" value="其他"></el-option>						
								</el-select>
							</el-form-item>
						</div>

						<div class="default">
							<!--邮编-->
							<el-form-item class="type3" prop="youbian">
								<el-input v-model="ruleForm.youbian" placeholder="邮编"></el-input>
							</el-form-item>

							<!--传真-->
							<el-form-item class="type3" prop="chuanzhen">
								<el-input v-model="ruleForm.chuanzhen" placeholder="传真"></el-input>
							</el-form-item>

							<!--电话-->
							<el-form-item class="type2" prop="dianhua">
								<el-input v-model="ruleForm.dianhua" placeholder="电话"></el-input>
							</el-form-item>
						</div>

						<div class="default">
							<!--是否有母公司-->
							<el-form-item class="type3" prop="whether">
								<el-select v-model="ruleForm.whether" placeholder="是否有母公司" @change='changeM($event)'>
									<el-option label="是" value="1"></el-option>
									<el-option label="否" value="0"></el-option>
								</el-select>
							</el-form-item>

							<!--母公司名称-->
							<el-form-item class="type4" prop="name1" v-show="showM">
								<el-input v-model="ruleForm.name1" placeholder="母公司名称"></el-input>
							</el-form-item>
						</div>

						<div class="default">
							<!--有无上级单位-->
							<el-form-item class="type3" prop="whether1">
								<el-select v-model="ruleForm.whether1" placeholder="有无上级单位" @change='changeY($event)'>
									<el-option label="是" value="1"></el-option>
									<el-option label="否" value="0"></el-option>
								</el-select>
							</el-form-item>

							<!--央企名称-->
							<el-form-item class="type4" prop="y_name" style="position: relative;" v-show="showY">
								<el-input v-model="ruleForm.y_name" placeholder="上级单位名称" ></el-input>
								<!--<ul class="list" v-show="list">
									@input="change"
									<li v-for="item in temp" @click="get_html($event)">{{item}}</li>
								</ul>-->
							</el-form-item>
						</div>

						<div class="default">
							<!--法人代表-->
							<el-form-item class="type3" prop="faren">
								<el-input v-model="ruleForm.faren" placeholder="法人代表"></el-input>
							</el-form-item>

							<!--职务-->
							<el-form-item class="type3" prop="zhiwu1">
								<el-input v-model="ruleForm.zhiwu1" placeholder="职务"></el-input>
							</el-form-item>

							<!--电话-->
							<el-form-item class="type2" prop="dianhua1">
								<el-input v-model="ruleForm.dianhua1" placeholder="电话(选填)"></el-input>
							</el-form-item>
						</div>

						<div class="default">
							<!--最高管理者-->
							<el-form-item class="type3" prop="leader">
								<el-input v-model="ruleForm.leader" placeholder="最高管理者"></el-input>
							</el-form-item>

							<!--职务-->
							<el-form-item class="type3" prop="zhiwu2">
								<el-input v-model="ruleForm.zhiwu2" placeholder="职务"></el-input>
							</el-form-item>

							<!--电话-->
							<el-form-item class="type2" prop="dianhua2">
								<el-input v-model="ruleForm.dianhua2" placeholder="电话(选填)"></el-input>
							</el-form-item>
						</div>

						<p class="tit_name">联系人信息</p>

						<!--联系部门-->
						<el-form-item prop="bumen">
							<el-input v-model="ruleForm.bumen" placeholder="联系部门"></el-input>
						</el-form-item>

						<div class="default">
							<!--负责人姓名-->
							<el-form-item class="type7" prop="name2">
								<el-input v-model="ruleForm.name2" placeholder="负责人姓名"></el-input>
							</el-form-item>

							<!--负责人职务-->
							<el-form-item class="type7" prop="fu_zhiwu">
								<el-input v-model="ruleForm.fu_zhiwu" placeholder="负责人职务"></el-input>
							</el-form-item>

							<!--负责人电话-->
							<el-form-item class="type7" prop="dianhua3">
								<el-input v-model="ruleForm.dianhua3" placeholder="负责人电话"></el-input>
							</el-form-item>

							<!--负责人Email-->
							<el-form-item class="type7" prop="email">
								<el-input v-model="ruleForm.email" placeholder="负责人Email"></el-input>
							</el-form-item>

							<!--负责人手机-->
							<el-form-item class="type7 fr" prop="dianhua4">
								<el-input v-model="ruleForm.dianhua4" placeholder="负责人手机"></el-input>
							</el-form-item>
						</div>

						<div class="default">
							<!--联系人姓名-->
							<el-form-item class="type7" prop="name3">
								<el-input v-model="ruleForm.name3" placeholder="联系人姓名"></el-input>
							</el-form-item>

							<!--联系人职务-->
							<el-form-item class="type7" prop="lian_zhiwu">
								<el-input v-model="ruleForm.lian_zhiwu" placeholder="联系人职务"></el-input>
							</el-form-item>

							<!--联系人电话-->
							<el-form-item class="type7" prop="dianhua5">
								<el-input v-model="ruleForm.dianhua5" placeholder="联系人电话"></el-input>
							</el-form-item>

							<!--联系人Email-->
							<el-form-item class="type7" prop="email1">
								<el-input v-model="ruleForm.email1" placeholder="联系人Email"></el-input>
							</el-form-item>

							<!--联系人手机-->
							<el-form-item class="type7 fr" prop="dianhua6">
								<el-input v-model="ruleForm.dianhua6" placeholder="联系人手机"></el-input>
							</el-form-item>
						</div>

						<p class="tit_name">经营概况</p>

						<!--主要产品与服务-->
						<el-form-item prop="product">
							<el-input v-model="ruleForm.product" placeholder="主要产品与服务"></el-input>
						</el-form-item>

						<div class="default">
							<!--总资产-->
							<el-form-item class="type5" prop="zichan">
								<el-input v-model="ruleForm.zichan" placeholder="总资产(万元)(选填)"></el-input>
							</el-form-item>

							<!--销售收入-->
							<el-form-item class="type5" prop="shouru">
								<el-input v-model="ruleForm.shouru" placeholder="销售收入(万元)(选填)"></el-input>
							</el-form-item>

							<!--总负债-->
							<el-form-item class="type5" prop="fuzhai">
								<el-input v-model="ruleForm.fuzhai" placeholder="总负债(万元)(选填)"></el-input>
							</el-form-item>

							<!--实现利税-->
							<el-form-item class="type5 margin_right" prop="lishui">
								<el-input v-model="ruleForm.lishui" placeholder="实现利税(万元)(选填)"></el-input>
							</el-form-item>
						</div>
						
						<!--企业质量管理状况-->
						<div class="default1">
							<div class="left">企业质量 <br>管理状况</div>
							<el-form-item class="status" prop="status">
								<el-input :rows="6" type="textarea" v-model="ruleForm.status" placeholder="1.产品和服务质量状况 2.通过体系认证情况 3.推行质量管理方法情况 4.上一年度年销售收入/利润 5.获得荣誉(附件)(350字内)(选填)"></el-input>
							</el-form-item>
							<span class="current_num">{{ruleForm.status.length}}</span>
						</div>

						<!--需求及建议-->
						<div class="default2">
							<div class="left1">对协会工作的<br>需求及建议</div>
							<el-form-item class="need" prop="need">
								<el-input type="textarea" :rows="3" v-model="ruleForm.need" placeholder="对协会工作的需求及建议(200字内)(选填)"></el-input>
							</el-form-item>
							<span class="current_num">{{ruleForm.need.length}}</span>
						</div>
						
						<div class="default2">
							<div class="left1" style="line-height: 73px;padding: 0;height: 73px;">会员风采</div>
							<el-form-item class="need" prop="mien">
								<el-input  type="textarea" :rows="3" v-model="ruleForm.mien"  placeholder="请填写50字以上的会员企业简介，企业成为正式会员后，会员风采内容将在协会官方公众号、官网会员天地—会员动态版块、会员管理系统首页发布。"></el-input>
							</el-form-item>
							<span class="current_num">{{ruleForm.mien.length}}</span>
						</div>

						<div class="default" style="margin-bottom: 35px;">
							<!--填表人-->
							<el-form-item class="type6" prop="tbr">
								<el-input v-model="ruleForm.tbr" placeholder="填表人"></el-input>
							</el-form-item>
							<!--填表时间-->
							<el-form-item class="type6 margin_right" required>
								<el-form-item prop="date1">
									<el-date-picker type="date" placeholder="填表时间" v-model="ruleForm.date1" align="right" :picker-options="pickerOptions" style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-form-item>
						</div>

						<p style="text-align: left;margin-bottom: 15px;">会员定期读物接收信息（请准确填写，以免影响会员服务）</p>
						<div class="default">
							<!--收件人姓名-->
							<el-form-item class="type3" prop="s_name">
								<el-input v-model="ruleForm.s_name" placeholder="收件人姓名"></el-input>
							</el-form-item>

							<!--收件人电话-->
							<el-form-item class="type3" prop="s_dianhua">
								<el-input v-model="ruleForm.s_dianhua" placeholder="收件人电话"></el-input>
							</el-form-item>

							<!--邮政编码-->
							<el-form-item class="type2" prop="s_youbian">
								<el-input v-model="ruleForm.s_youbian" placeholder="邮政编码"></el-input>
							</el-form-item>
						</div>

						<!--<div class="default">
							<el-select v-model="prov" class="type3">
								<el-option v-for="(option,index) in arr" :key="index" :value="option.name">
									{{ option.name }}
								</el-option>
							</el-select>
							<el-select v-model="city" class="type3">
								<el-option v-for="(option,index) in cityArr" :key="index" :value="option.name">
									{{ option.name }}
								</el-option>
							</el-select>
							<el-select v-model="district" v-if="district" class="type2">
								<el-option v-for="(option,index) in districtArr" :key="index" :value="option.name">
									{{ option.name }}
								</el-option>
							</el-select>
						</div>-->

						<el-form-item prop="xaddress">
							<el-input v-model="ruleForm.xaddress" placeholder="完整地址"></el-input>
						</el-form-item>
						<p style="text-align: left;margin-bottom: 15px;">后期是否有升级为理事会员单位的意愿？（此项仅为意向，具体申请资格与席位有严格的审批流程，成为会员后可在页面查看相应流程）</p>
						<p style="text-align: left;margin-bottom: 30px;">
							<el-radio-group v-model="yes_no">
								<el-radio label="是"></el-radio>
								<el-radio label="否"></el-radio>
							</el-radio-group>
						</p>
						<div style="width: 100%;height: auto;overflow: hidden;">
							<span style="display: inline-block;vertical-align: top;height: 32px;line-height: 32px;">上传证明材料</span>
							<div class="add" style="display: inline-block;">
								<label for="file" style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;z-index: 10; "></label>
								<input type="file" id="file" class="file" @change="uploadFile($event)" multiple="multiple" accept='.jpg,.png,.zip'>
							</div>
							<p>{{filename}}</p>
							<p style="color: red;">支持png/jpg，若上传文件较多可上传压缩包（zip），单个文件可直接上传，文件小于10M（注：上传文件只需一次，多次将会覆盖）。</p>
						</div>
						<p style="color: red;margin-bottom: 15px;">
							温馨提示：为了规范会员管理制度，保证会员自身权益。除修改“联系人信息”以外内容，请务必上传相关证明性文件，如未按要求提交信息变更，将无法通过审批。
							现有单位会员补充更新信息，无需上传相关证明性文件。
						</p>

						<el-form-item class="btn_box">
							<el-button class="btn" type="primary" @click="submitForm('ruleForm')">提交</el-button>

						</el-form-item>
					</el-form>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import { Loading } from 'element-ui'
	import area from '../../static/js/area.js'
	import Qs from 'qs'
	export default {
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}]
				},
				showM:true,
				showY:true,				
				file: '',
				filename: '',
				list: false,
				temp: [],
				name: 'Cselect',
				arr: area.arrAll,
//				prov: '省份',
//				city: '城市',
//				district: '区域',
				cityArr: [],
				districtArr: [],
				yes_no: null,
				ruleForm: {
					name: '',
					sort: '',
					addres1: '',
					people_num: '',
					prov:'',
					addres2: '',
					kind: '',
					youbian: '',
					chuanzhen: '',
					dianhua: '',
					whether: '',
					name1: '',
					whether1:'',
					y_name:'',
					faren: '',
					zhiwu1: '',
					dianhua1: '',
					leader: '',
					zhiwu2: '',
					dianhua2: '',
					bumen: '',
					name2: '',
					fu_zhiwu: '',
					dianhua3: '',
					email: '',
					dianhua4: '',
					name3: '',
					lian_zhiwu: '',
					dianhua5: '',
					email1: '',
					dianhua6: '',
					product: '',
					zichan: '',
					shouru: '',
					fuzhai: '',
					lishui: '',
					status: '',
					need: '',
					mien:'',
					tbr: '',
					date1: '',
					s_name: '',
					s_dianhua: '',
					s_youbian: '',
					selectedOptions: '',
					xaddress: '',
				},
				rules: {
					name: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}, ],
					sort: [{
						required: true,
						message: '请选择行业类别',
						trigger: 'change'
					}],
					addres1: [{
						required: true,
						message: '请输入通讯地址',
						trigger: 'blur'
					}, ],
					people_num: [{
						required: true,
						message: '请选择职工人数',
						trigger: 'blur'
					}, ],
					prov: [{
						required: true,
						message: '请选择省份',
						trigger: 'blur'
					}, ],
//					addres2: [{
//						required: true,
//						message: '请输入单位网址',
//						trigger: 'blur'
//					}, ],
					kind: [{
						required: true,
						message: '请选择企业性质',
						trigger: 'blur'
					}, ],
					youbian: [{
						required: true,
						message: '请输入邮编',
						trigger: 'blur'
					},
					{ pattern: /^[0-9]{6}$/, message: '输入正确的邮编' }
					],
					chuanzhen: [{
						required: true,
						message: '请输入传真',
						trigger: 'blur'
					}, ],
					dianhua: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}, ],
					whether: [{
						required: true,
						message: '请选择是否有母公司',
						trigger: 'blur'
					}, ],
					whether1: [{
						required: true,
						message: '请选择是否是央企',
						trigger: 'blur'
					}, ],
					faren: [{
						required: true,
						message: '请输入法人代表',
						trigger: 'blur'
					}, ],
					zhiwu1: [{
						required: true,
						message: '请输入职务',
						trigger: 'blur'
					}, ],
//					dianhua1: [{
//						required: true,
//						message: '请输入电话',
//						trigger: 'blur'
//					}, ],
					leader: [{
						required: true,
						message: '请输入最高管理者',
						trigger: 'blur'
					}, ],
					zhiwu2: [{
						required: true,
						message: '请输入职务',
						trigger: 'blur'
					}, ],
//					dianhua2: [{
//						required: true,
//						message: '请输入电话',
//						trigger: 'blur'
//					}, ],
					bumen: [{
						required: true,
						message: '请输入联系部门',
						trigger: 'blur'
					}, ],
					name2: [{
						required: true,
						message: '请输入负责人姓名',
						trigger: 'blur'
					}, ],
					fu_zhiwu: [{
						required: true,
						message: '请输入负责人职务',
						trigger: 'blur'
					}, ],
					dianhua3: [{
						required: true,
						message: '请输入负责人电话',
						trigger: 'blur'
					}, ],
					email: [{
						required: true,
						message: '请输入负责人Email',
						trigger: 'blur'
					}, 
					{ pattern:  /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: '输入正确的邮箱' }
					],
					dianhua4: [{
						required: true,
						message: '请输入负责人手机',
						trigger: 'blur'
					},
					{ pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: '输入11位手机号' }
					],
					name3: [{
						required: true,
						message: '请输入联系人姓名',
						trigger: 'blur'
					}, ],
					lian_zhiwu: [{
						required: true,
						message: '请输入联系人职务',
						trigger: 'blur'
					}, ],
					dianhua5: [{
						required: true,
						message: '请输入联系人电话',
						trigger: 'blur'
					}, ],
					email1: [{
						required: true,
						message: '请输入联系人Email',
						trigger: 'blur'
					}, 
					{ pattern:  /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: '输入正确的邮箱' }
					],
					dianhua6: [{
						required: true,
						message: '请输入联系人手机',
						trigger: 'blur'
					},
					{ pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: '输入11位手机号' }
					],
					product: [{
						required: true,
						message: '请输入主要产品与服务',
						trigger: 'blur'
					}, ],
//					zichan: [{
//						required: true,
//						message: '请输入总资产',
//						trigger: 'blur'
//					}, ],
//					shouru: [{
//						required: true,
//						message: '请输入销售收入',
//						trigger: 'blur'
//					}, ],
//					fuzhai: [{
//						required: true,
//						message: '请输入总负债',
//						trigger: 'blur'
//					}, ],
//					lishui: [{
//						required: true,
//						message: '请输入实现利税',
//						trigger: 'blur'
//					}, ],
					tbr: [{
						required: true,
						message: '请输入填表人',
						trigger: 'blur'
					}, ],
//					status: [{
//						required: true,
//						message: '请输入企业质量 管理状况',
//						trigger: 'blur'
//					}, ],
//					need: [{
//						required: true,
//						message: '请输入对协会工作的 需求及建议',
//						trigger: 'blur'
//					}, ],
					mien:[{
						required: true,
						message: '请填写50-200字的会员企业简介',
						trigger: 'blur'
					}, ],
					date1: [{
						type: 'date',
						required: true,
						message: '请选择日期',
						trigger: 'change'
					}],

					s_name: [{
						required: true,
						message: '请输入收件人姓名',
						trigger: 'blur'
					}],
					s_dianhua: [{
						required: true,
						message: '请输入收件人电话',
						trigger: 'blur'
					}],
					s_youbian: [{
						required: true,
						message: '请输入邮政编码',
						trigger: 'blur'
					},
					{ pattern: /^[0-9]{6}$/, message: '输入正确的邮编' }
					],
					xaddress: [{
						required: true,
						message: '请输入完整地址',
						trigger: 'blur'
					}],
				}

			};
		},
		props: {
			showXinxi: {
				type: Boolean
			}
		},
		created() {},
		mounted() {
			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
			var data1={
				'access-token':token
			};
			this.$axios({
				method: 'post',
				url: 'society/showcompany',
				data: Qs.stringify(data1)
			}).then(response => {				
				if(response.data.state==3){
					var data = response.data.result;
					if(data.length != 0) {
						this.ruleForm.name = data.name;
						this.ruleForm.sort = data.professions;
						this.ruleForm.addres1 = data.address;
						this.ruleForm.people_num = data.number;
						this.ruleForm.addres2 = data.website;
						this.ruleForm.kind = data.company_type;
						this.ruleForm.youbian = data.postcode;
						this.ruleForm.chuanzhen = data.fax;
						this.ruleForm.dianhua = data.fax_tel;
						this.ruleForm.whether = data.has_parent;
						if(data.has_parent=='0'){
							this.showM = false;
						};
						this.ruleForm.name1 = data.parent_name;
						this.ruleForm.whether1 = data.central_enterprise;
						if(data.central_enterprise=='0'){
							this.showY = false;
						}
						this.ruleForm.y_name = data.central_enterprise_name;
						this.ruleForm.faren = data.corporate;
						this.ruleForm.zhiwu1 = data.corporate_title;
						this.ruleForm.dianhua1 = data.corporate_tel;
						this.ruleForm.leader = data.ceo;
						this.ruleForm.zhiwu2 = data.ceo_title;
						this.ruleForm.dianhua2 = data.ceo_tel;
						this.ruleForm.bumen = data.department;
						this.ruleForm.name2 = data.department_manager;
						this.ruleForm.fu_zhiwu = data.department_title;
						this.ruleForm.dianhua3 = data.manager_tel;
						this.ruleForm.email = data.manager_email;
						this.ruleForm.dianhua4 = data.manager_phone;
						this.ruleForm.name3 = data.user_name;
						this.ruleForm.lian_zhiwu = data.user_title;
						this.ruleForm.dianhua5 = data.user_tel;
						this.ruleForm.email1 = data.user_email;
						this.ruleForm.dianhua6 = data.user_phone;
						this.ruleForm.product = data.service;
						this.ruleForm.zichan = data.total_assets;
						this.ruleForm.shouru = data.revenue;
						this.ruleForm.fuzhai = data.total_debt;
						this.ruleForm.lishui = data.profit;						
						this.ruleForm.status = data.condition == null? '':data.condition;						
						this.ruleForm.need = data.suggestion == null? '':data.suggestion;						
						this.ruleForm.mien = data.mien == null? '':data.mien;
						this.ruleForm.tbr = data.username;
						this.ruleForm.s_name = data.addressee_name;
						this.ruleForm.s_dianhua = data.addressee_phone;
						this.ruleForm.s_youbian = data.postcode;
						this.ruleForm.prov = data.province;
						if(data.intention==1){
							this.yes_no='是';
						}else{
							this.yes_no='否';
						}
	//					this.city = data.city;
	//					this.district = data.district;
						this.ruleForm.xaddress = data.detailed_address;
					}
				}

			});
		},
		methods: {
			uploadFile(event) {
				const isLt2M = event.target.files[0].size / 1024 / 1024 < 10 // 上传头像图片大小不能超过 2MB
				if(!isLt2M) {
					this.$toast('图片选择失败，每张图片大小不能超过 10MB,请重新选择!');
				} else {
					this.file = event.target.files[0]; //获取input的图片file值
					this.filename = event.target.files[0].name;
					this.$toast('文件选择成功!');
				}
			},
			changeM(e){
				if(e == 1){
					this.showM = true;
				}else{
					this.showM = false;
					this.ruleForm.name1 ='';
				}
			},
			changeY(e){
				if(e == 1){
					this.showY = true;
				}else{
					this.showY = false;
					this.ruleForm.y_name ='';
				}
			},
//			get_html(event) {
//				console.log(event.currentTarget.innerHTML);
//				this.ruleForm.y_name = event.currentTarget.innerHTML;
//				this.list = false;
//			},
//			change() {
//				console.log(this.ruleForm.y_name);
//				this.temp = [];
//				this.list = false;
//				var data_arr = [
//					'中国核工业集团有限公司', '中国航天科技集团有限公司', '中国航天科工集团有限公司', '中国航空工业集团有限公司', '中国船舶工业集团有限公司', '中国船舶重工集团有限公司', '国家电网有限公司', '中国南方电网有限责任公司',
//					'中国华能集团有限公司', '中国大唐集团有限公司', '中国华电集团有限公司', '国家电力投资集团有限公司', '中国长江三峡集团有限公司', '国家能源投资集团有限责任公司', '中国电信集团有限公司', '中国联合网络通信集团有限公司',
//					'中国移动通信集团有限公司', '中国电子信息产业集团有限公司', '中国第一汽车集团有限公司', '东风汽车集团有限公司', '中国一重集团有限公司', '中国机械工业集团有限公司', '哈尔滨电气集团有限公司', '中国东方电气集团有限公司',
//					'鞍钢集团有限公司', '中国宝武钢铁集团有限公司', '中国铝业集团有限公司', '中国远洋海运集团有限公司', '中国航空集团有限公司', '中国东方航空集团有限公司', '中国南方航空集团有限公司', '中国中化集团有限公司', '中粮集团有限公司',
//					'中国五矿集团有限公司', '中国通用技术（集团）控股有限责任公司', '中国建筑集团有限公司', '中国储备粮管理集团有限公司', '国家开发投资集团有限公司', '招商局集团有限公司', '华润（集团）有限公司', '中国旅游集团有限公司[香港中旅（集团）有限公司]',
//					'中国商用飞机有限责任公司', '中国节能环保集团有限公司', '中国国际工程咨询有限公司', '中国诚通控股集团有限公司', '中国中煤能源集团有限公司', '中国煤炭科工集团有限公司', '机械科学研究总院集团有限公司', '中国中钢集团有限公司', '中国钢研科技集团有限公司',
//					'中国化工集团有限公司', '中国化学工程集团有限公司', '中国盐业集团有限公司', '中国建材集团有限公司', '中国有色矿业集团有限公司', '有研科技集团有限公司', '北京矿冶科技集团有限公司', '中国国际技术智力合作有限公司', '中国建筑科学研究院有限公司',
//					'中国中车集团有限公司', '中国铁路通信信号集团有限公司', '中国铁路工程集团有限公司', '中国铁道建筑集团有限公司', '中国交通建设集团有限公司', '中国普天信息产业集团有限公司', '中国信息通信科技集团有限公司', '中国农业发展集团有限公司',
//					'中国中丝集团有限公司', '中国林业集团有限公司', '中国医药集团有限公司', '中国保利集团有限公司', '中国建设科技有限公司', '中国冶金地质总局', '中国煤炭地质总局', '新兴际华集团有限公司', '中国民航信息集团有限公司',
//					'中国航空油料集团有限公司', '中国航空器材集团有限公司', '中国电力建设集团有限公司', '中国能源建设集团有限公司', '中国安能建设集团有限公司', '中国黄金集团有限公司', '中国广核集团有限公司',
//					'中国华录集团有限公司', '上海诺基亚贝尔股份有限公司', '华侨城集团有限公司', '南光（集团）有限公司[中国南光集团有限公司]', '中国西电集团有限公司', '中国铁路物资集团有限公司', '中国国新控股有限责任公司'
//				];
//				if(!this.ruleForm.y_name) {
//					return false;
//				}
//
//				for(var i in data_arr) {
//					if(data_arr[i].indexOf(this.ruleForm.y_name) >= 0) {
//						this.temp.push(data_arr[i]);
//						this.list = true;
//					}
//
//				}
//				console.log(this.temp);
//
//			},
//			updateCity: function() {
//				for(var i in this.arr) {
//					var obj = this.arr[i];
//					if(obj.name) {
//						if(obj.name == this.prov) {
//							this.cityArr = obj.sub;
//							break;
//						}
//					}
//				}
//				this.city = this.cityArr[1].name;
//			},
//			updateDistrict: function() {
//				for(var i in this.cityArr) {
//					var obj = this.cityArr[i];
//					if(obj.name == this.city) {
//						this.districtArr = obj.sub;
//						break;
//					}
//				}
//				if(this.districtArr && this.districtArr.length > 0 && this.districtArr[1].name) {
//					this.district = this.districtArr[1].name;
//				} else {
//					this.district = '';
//				}
//			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if(valid) {
						if(this.ruleForm.whether == '1') {
							if(this.ruleForm.name1 == '' || this.ruleForm.name1 == ' ') {
								this.$toast('请输入母公司名称');
								return false;
							}
						}
						if(this.ruleForm.whether1 == '1') {
							if(this.ruleForm.y_name == '' || this.ruleForm.y_name == ' ') {
								this.$toast('请输入央企名称');
								return false;								
							}
						}
//						if(this.prov == '省份') {
//							this.$toast('请选择省份');
//							return false;
//						};
//						if(this.city == '城市') {
//							this.$toast('请选择城市');
//							return false;
//						};
//						if(this.district == '区域') {
//							this.$toast('请选择区域');
//							return false;
//						};
						if(this.ruleForm.status.length>350) {
							this.$toast('企业质量管理状况超出了350字！');
							return false;
						};
						if(this.ruleForm.need.length>200) {
							this.$toast('对协会工作的需求及建议超出了200字！');
							return false;
						};
						if(this.ruleForm.mien.length<50) {
							this.$toast('请填写50字以上的会员企业简介');
							return false;
						};
						if(!this.yes_no) {
							this.$toast('请选择后期是否有升级为理事会员单位的意愿？');
							return false;
						};
//						if(this.filename == "") {
//							this.$toast('请选择要上传的文件！')
//							return false
//						};
						Loading.service();
						if(this.yes_no == '是') {
							var intention = 1;
						} else {
							var intention = 2;
						}
						if(sessionStorage.getItem('Token')) {
							var token = sessionStorage.getItem('Token');
						}
						if(this.filename !=''){
							let fileFormData = new FormData();
							fileFormData.append('file', this.file, this.filename); //filename是键，file是值，就是要传的文件，test.zip是要传的文件名
							let requestConfig = {
								headers: {
									'Content-Type': 'multipart/form-data'
								},
							};
							fileFormData.append('access-token',token);
							fileFormData.append('name', this.ruleForm.name);
							fileFormData.append('professions', this.ruleForm.sort);
							fileFormData.append('address', this.ruleForm.addres1);
							fileFormData.append('number', this.ruleForm.people_num);
							fileFormData.append('website', this.ruleForm.addres2);
							fileFormData.append('company_type', this.ruleForm.kind);
							fileFormData.append('postcode', this.ruleForm.youbian);
							fileFormData.append('fax', this.ruleForm.chuanzhen);
							fileFormData.append('fax_tel', this.ruleForm.dianhua);
							fileFormData.append('has_parent', this.ruleForm.whether);
							fileFormData.append('parent_name', this.ruleForm.name1);
							fileFormData.append('central_enterprise', this.ruleForm.whether1);
							fileFormData.append('central_enterprise_name', this.ruleForm.y_name);
							fileFormData.append('corporate', this.ruleForm.faren);
							fileFormData.append('corporate_title', this.ruleForm.zhiwu1);
							fileFormData.append('corporate_tel', this.ruleForm.dianhua1);
							fileFormData.append('ceo', this.ruleForm.leader);
							fileFormData.append('ceo_title', this.ruleForm.zhiwu2);
							fileFormData.append('ceo_tel', this.ruleForm.dianhua2);
							fileFormData.append('department', this.ruleForm.bumen);
							fileFormData.append('department_manager', this.ruleForm.name2);
							fileFormData.append('department_title', this.ruleForm.fu_zhiwu);
							fileFormData.append('manager_tel', this.ruleForm.dianhua3);
							fileFormData.append('manager_email', this.ruleForm.email);
							fileFormData.append('manager_phone', this.ruleForm.dianhua4);
							fileFormData.append('user_name', this.ruleForm.name3);
							fileFormData.append('user_title', this.ruleForm.lian_zhiwu);
							fileFormData.append('user_tel', this.ruleForm.dianhua5);
							fileFormData.append('user_email', this.ruleForm.email1);
							fileFormData.append('user_phone', this.ruleForm.dianhua6);
							fileFormData.append('service', this.ruleForm.product);
							fileFormData.append('total_assets', this.ruleForm.zichan);
							fileFormData.append('revenue', this.ruleForm.shouru);
							fileFormData.append('total_debt', this.ruleForm.fuzhai);
							fileFormData.append('profit', this.ruleForm.lishui);
							fileFormData.append('condition', this.ruleForm.status);
							fileFormData.append('suggestion', this.ruleForm.need);
							fileFormData.append('mien', this.ruleForm.mien);
							fileFormData.append('username', this.ruleForm.tbr);
							fileFormData.append('apply_time', this.ruleForm.date1.toISOString().slice(0, 10));
							fileFormData.append('addressee_name', this.ruleForm.s_name);
							fileFormData.append('addressee_phone', this.ruleForm.s_dianhua);
							fileFormData.append('addressee_zipcode', this.ruleForm.s_youbian);
							fileFormData.append('province', this.ruleForm.prov);
	//						fileFormData.append('city', this.city);
	//						fileFormData.append('district', this.district);
							fileFormData.append('detailed_address', this.ruleForm.xaddress);
							fileFormData.append('intention', intention);
							this.$axios.post('society/companyupdates', fileFormData, requestConfig).then(response => {
								let loadingInstance = Loading.service();
								loadingInstance.close();
								this.$toast(response.data.msg);
							});														
						}else{
							let data = {
								'access-token':token,
								'name': this.ruleForm.name,
								'professions': this.ruleForm.sort,
								'address': this.ruleForm.addres1,
								'number': this.ruleForm.people_num,
								'website': this.ruleForm.addres2,
								'company_type': this.ruleForm.kind,
								'postcode': this.ruleForm.youbian,
								'fax': this.ruleForm.chuanzhen,
								'fax_tel': this.ruleForm.dianhua,
								'has_parent': this.ruleForm.whether,
								'parent_name': this.ruleForm.name1,
								'central_enterprise': this.ruleForm.whether1,
								'central_enterprise_name': this.ruleForm.y_name,
								'corporate': this.ruleForm.faren,
								'corporate_title': this.ruleForm.zhiwu1,
								'corporate_tel': this.ruleForm.dianhua1,
								'ceo': this.ruleForm.leader,
								'ceo_title': this.ruleForm.zhiwu2,
								'ceo_tel': this.ruleForm.dianhua2,
								'department': this.ruleForm.bumen,
								'department_manager': this.ruleForm.name2,
								'department_title': this.ruleForm.fu_zhiwu,
								'manager_tel': this.ruleForm.dianhua3,
								'manager_email': this.ruleForm.email,
								'manager_phone': this.ruleForm.dianhua4,
								'user_name': this.ruleForm.name3,
								'user_title': this.ruleForm.lian_zhiwu,
								'user_tel': this.ruleForm.dianhua5,
								'user_email': this.ruleForm.email1,
								'user_phone': this.ruleForm.dianhua6,
								'service': this.ruleForm.product,
								'total_assets': this.ruleForm.zichan,
								'revenue': this.ruleForm.shouru,
								'total_debt': this.ruleForm.fuzhai,
								'profit': this.ruleForm.lishui,
								'condition': this.ruleForm.status,
								'suggestion': this.ruleForm.need,
								'mien':this.ruleForm.mien,
								'username': this.ruleForm.tbr,
								'referrer':this.ruleForm.referrer,
								'apply_time': this.ruleForm.date1.toISOString().slice(0, 10),
								'addressee_name': this.ruleForm.s_name,
								'addressee_phone': this.ruleForm.s_dianhua,
								'addressee_zipcode': this.ruleForm.s_youbian,
								'province': this.ruleForm.prov,
								'detailed_address': this.ruleForm.xaddress,
								'intention': intention,
							};
							this.$axios({
								method: 'post',
								url: 'society/companyupdates',
								data: Qs.stringify(data)
							}).then(response => {
								let loadingInstance = Loading.service();
								loadingInstance.close();
								this.$toast(response.data.msg);
							});
							
						}
						
						

					} else {
						this.$toast('请完善资料后再提交');
					}
				});
			},
		}
	}
</script>
<style scoped>
	.clearfix::after {
		content: ".";
		clear: both;
		visibility: hidden;
		height: 0;
		display: block;
		line-height: 0;
	}
	
	.clearfix {
		zoom: 1;
	}
	
	.fl {
		float: left;
	}
	
	.fr {
		float: right;
	}
	
	.rap {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.xinxi {
		width: 100%;
		height: auto;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	
	.con {
		width: 100%;
		height: auto;
		position: relative;
	}
	
	.con_tit {
		padding-left: 18px;
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.con_tit span{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	
	.con_con {
		padding: 20px 37px 0 41px;
		width: 100%;
		height: auto;
		/*border: 1px solid rgba(207, 212, 214, 1);*/
		box-sizing: border-box;
	}
	
	.con_con_tit {
		font-size: 16px;
		font-weight: bold;
		line-height: 35px;
		border-bottom: 1px solid #CFD4D6;
		margin-bottom: 6px;
	}
	
	.form {
		margin: 23px auto 32px;
		width: 819px;
		height: auto;
		border: 1px solid rgba(231, 231, 231, 1);
	}
	
	.form h5 {
		height: 60px;
		border-bottom: 1px solid #E7E7E7;
		line-height: 60px;
		color: #404040;
		font-size: 20px;
		font-weight: bold;
	}
	
	.msg_box {
		position: relative;
		width: 590px;
		height: auto;
		margin: 22px auto 0;
		overflow: hidden;
	}
	
	.margin0 {
		margin-bottom: 0;
	}
	
	.tit_name {
		text-align: left;
		font-size: 18px;
		color: #4F4F4F;
		line-height: 45px;
		font-weight: bold;
	}
	
	.default {
		width: 100%;
		height: 40px;
		margin-bottom: 21px;
	}
	
	.type1 {
		float: left;
		width: 362px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
	}
	
	.type2 {
		float: right;
		width: 208px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
	}
	
	.type3 {
		float: left;
		width: 174px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 13px;
	}
	
	.type4 {
		float: right;
		width: 403px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
	}
	
	.type5 {
		float: left;
		width: 140px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 10px;
	}
	
	.type6 {
		float: left;
		width: 287px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 15px;
	}
	
	.type7 {
		float: left;
		width: 108px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 11px;
	}
	
	.list {
		border: 1px solid #CECECE;
		background: #fff;
		border-radius: 5px;
		width: 100%;
		height: 200px;
		position: absolute;
		left: 0;
		top: 40px;
		z-index: 9999;
		overflow-y: scroll;
		box-sizing: border-box;
	}
	
	.list li {
		cursor: pointer;
		height: 40px;
		line-height: 40px;
	}
	
	.list li:hover {
		background: #F5F7FA;
	}
	
	.fr {
		float: right;
		margin-right: 0;
	}
	
	.margin_right {
		float: right;
		margin-right: 0;
	}
	
	.default1 {
		position: relative;
		width: 100%;
		height: 140px;
		margin-bottom: 22px;
		border: 1px solid #E7E7E7;
		box-sizing: border-box;
	}
	
	.left {
		width: 134px;
		height: 91px;
		background: rgba(250, 250, 250, 1);
		border-radius: 3px 0px 0px 3px;
		border: 1px solid #E7E7E7;
		float: left;
		padding-top: 45px;
		text-align: center;
		color: #808080;
	}
	
	.status {
		width: 452px;
		float: right;
	}
	
	.default2 {
		position: relative;
		width: 100%;
		height: 77px;
		margin-bottom: 22px;
		border: 1px solid #E7E7E7;
		box-sizing: border-box;
	}
	.current_num{
		position: absolute;
		bottom: 0;
		right: 10px;
		color: red;
	}
	.left1 {
		width: 134px;
		height: 53px;
		background: rgba(250, 250, 250, 1);
		border-radius: 3px 0px 0px 3px;
		border: 1px solid #E7E7E7;
		float: left;
		padding-top: 20px;
		text-align: center;
		color: #808080;
	}
	
	.need {
		width: 452px;
		float: right;
	}
	
	.btn {
		display: block;
		border: none;
		margin: 0 auto;
		width: 160px;
		height: 48px;
		background: rgba(6, 98, 181, 1);
		border-radius: 4px;
		color: #fff;
	}
	
	.add {
		position: relative;
		cursor: pointer;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
		line-height: 32px;
		width: 106px;
		height: 32px;
		background: rgba(255, 255, 255, 1) url(../../static/img/input.png) no-repeat;
		background-size: 100%;
	}
	.add:active{
		background: rgba(24, 144, 255, 1);
		color: #fff;
		border:none;
	}
	.file {
		position: absolute;
		left: -9999px;
	}
	
	.note {
		color: #CFD4D6;
		text-indent: 100px;
	}
	
	.btn {
		width: 160px;
		height: 48px;
		background: rgba(0, 118, 255, 1);
		border-radius: 4px;
		color: #fff;
		border: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/Xinxi.vue